export default __webpack_public_path__ + "static/dynamic_back-222770cb63ffb9b549063a2f55fb16a2.webp";